module.exports = __webpack_public_path__ + "static/media/CuadernoApaisado.5eb0c8a0.png";